import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DashboardCardComponent } from './dashboard/dashboard-card/dashboard-card.component';
import { DashboardLoggedUsersComponent } from './dashboard/dashboard-logged-users/dashboard-logged-users.component';
import { DashboardTaskDetailsDialogComponent } from './dashboard/dashboard-logged-users/dashboard-task-details-dialog/dashboard-task-details-dialog.component';
import { DashboardOverviewComponent } from './dashboard/dashboard-overview/dashboard-overview.component';
import { DashboardReportsComponent } from './dashboard/dashboard-reports/dashboard-reports.component';
import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { MetricsDialogContainerForAjsComponent } from './shared/components/report-edition-dialog/metrics-dialog-container-for-ajs/metrics-dialog-container-for-ajs.component';
import { ReportEditionDetailsComponent } from './shared/components/report-edition-dialog/report-edition-details/report-edition-details.component';
import { ReportEditionFormComponent } from './shared/components/report-edition-dialog/report-edition-form/report-edition-form.component';
import { ReportEditionMetricDialogComponent } from './shared/components/report-edition-dialog/report-edition-metric-dialog/report-edition-metric-dialog.component';
import { ReportEditionVerbatimDialogComponent } from './shared/components/report-edition-dialog/report-edition-verbatim-dialog/report-edition-verbatim-dialog.component';

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardOverviewComponent,
    DashboardCardComponent,
    DashboardLoggedUsersComponent,
    DashboardTaskDetailsDialogComponent,
    DashboardReportsComponent,
    MetricsDialogContainerForAjsComponent,
    ReportEditionDetailsComponent,
    ReportEditionMetricDialogComponent,
    ReportEditionVerbatimDialogComponent,
    ReportEditionFormComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class MetricsModule {}
